import { Middleware, Context } from '@nuxt/types';

const hubspot: Middleware = (context: Context) => {
  context.app.$hubspot.identifyAndTrack();
};

export default hubspot;
